<template>
  <div class="item">
    <div class="card">
      <div class="info">
        <el-image class="img" :src="product.image"></el-image>
        <!--        <img class="img" :src="product.image">-->
        <div class="text">
          <div class="time">{{ delBtn ? '咨询' : '浏览' }}时间：{{ product.add_time |moments }}</div>
          <div class="name" @click.stop=""><span>{{ product.game_name }}</span>{{ product.name }}</div>
          <div class="sign">
            <img src="@/assets/image/AllGame/isSign.png" alt="">
            <img v-if="product.bind_psn === 1" src="@/assets/image/AllGame/bindPsn.png" alt="">
            <img v-if="product.bind_tap === 1" src="@/assets/image/AllGame/bindTap.png" alt="">
          </div>

          <div class="other">
            <div class="zone">游戏区服：<span v-for="(item,index) in product.category" :key="index">{{ item.value }}<span
              v-if="index !=  product.category.length-1">-</span> </span></div>
            <div class="hot">热度：{{ product.click }}</div>
          </div>
        </div>
      </div>
      <div class="price">¥{{ product.price }}</div>

      <div class="btnGroup" v-if="delBtn">
        <div class="infoBtn" v-if="infoBtn" @click.stop="gotoPath">查看详情</div>
        <div class="cusSerBtn" target="_blank"  @click.stop="cusSerClick">继续咨询</div>
        <div class="delBtn" @click.stop="delClick(product.id)">删除记录</div>
      </div>
      <div class="btnGroup" v-else>
        <div class="infoBtn" v-if="infoBtn" @click.stop="gotoPath">查看详情</div>
        <a class="cusSerBtn" v-if="cusSerBtn" target="_blank" @click.stop="cusSerClick">咨询客服</a>
      </div>
    </div>
  </div>
</template>

<script>
import {apiHistoryCusAdd,apiStatisticsAdd,apiProductBuyCheck} from "@/request/API";

export default {
  name: "historyItem",
  props: {
    product: {
      type: Object,
      default: null
    },
    infoBtn: {
      type: Boolean,
      default: false,
    },
    cusSerBtn: {
      type: Boolean,
      default: false,
    },
    delBtn: {
      type: Boolean,
      default: false,
    },
    delClick: {
      type: Function,
      default: null
    },
  },
  methods: {
    /**
     * 跳转商品详情页面
     */
    gotoPath() {
      let name = this.product.product_type === 1 ? 'GameDetails' : 'EquipmentDetails'
      if (this.product.product_type === 1) {
        this.$sensorsTrack.AccountClick(
          this.$route.name,
          this.currentPage,
          `${this.product.game_alias}_${this.product.id}`,
          this.product.game_name,
          this.product.game_id,
          this.product.user_id,
          '',
          '',
          `${this.product.game_alias}_${this.product.id}`,
          '游戏账号',
          '',
          '',
          '',
          '',
          '',
        )
      }
      this.$router.push({
        name: name,
        query: {
          game_id: this.product.game_id,
          id: this.product.product_id,
          source_page: this.$route.path.slice(1)
        }
      });
    },
    /**
     * 立即购买按钮
     */
     onlineBuy(game_id, id){
      if (!this.$store.state.loginStatus) {
        this.$message({
          type: "error",
          message: '尚未登录，请先登录。',
          center: true
        })
        this.$router.push({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath,
            game_name: this.product.game_name,
            game_id: game_id,
            id: id,
          },
        })
        return;
      }
      apiProductBuyCheck({
        game_id:game_id,
        id:id,
      }).then(res=>{
        let routeUrl = this.$router.resolve({
          name: 'OnlineDeal',
          query: {
            id: id,
            game_id:game_id
          }
        });
        window.open(routeUrl.href, '_blank');
      }).catch(e => {
        this.$message.error(e.msg)
      })
    },
    /**
     * 联系客服
     */
    cusSerClick(){
      apiStatisticsAdd({
        game_id:this.product.game_id,
        product_id:this.product.product_id,
        statistics_type:3
      })
      apiHistoryCusAdd({
        game_id: this.product.game_id,
        product_id: this.product.product_id,
        product_type: this.product.product_type,
      }).then(res=>{
        if (this.delBtn) {
          this.$emit('reload')
        }
      })
      if(this.product.game_id && this.product.product_id){
        this.$customerShunt.getBuyOrGroupCode(this.product.product_id, this.product.game_id, this.product.product_type, (data) => {
          if(data.game_buy_status){
            data.allot_group_buy_status ? this.onlineBuy(this.product.game_id, this.product.product_id) : this.$openIM({
              product_id: this.product.product_id,
              game_id: this.product.game_id,
              shopid: this.product.product_id,
              product_type: this.product.product_type,
              gameAlias: data.group_code,
              im_type: 3
            })
          } else {
            this.$openIM({
              product_id: this.product.product_id,
              game_id: this.product.game_id,
              shopid: this.product.product_id,
              product_type: this.product.product_type,
              gameAlias: data.group_code,
              im_type: 3
            })
          }
        })
      } else {
        if([2,3].includes(this.product.sys_service_type)){
          const {game_alias, game_id, product_id, product_type} = this.product
          this.$openIM({
            game_id,
            shopid: product_id,
            product_id,
            product_type: product_type,
            gameAlias: game_alias,
          })
        }else{
          this.$accessLink(this.product.buy_customer)
          var api = $53.createApi()
          api.push('cmd', 'comeinfo');
          api.push('title', this.product.name);
          api.push('logo', this.product.image);
          api.push('content', `商品价格:${this.product.price}`);
          api.push('curl',`${process.env.VUE_APP_WEBSITE}/gamedetails?game_id=${this.product.game_id}&id=${this.product.product_id}`);
          api.query();
          api.push('cmd', 'kfclient');
          api.push('type', 'new');
          api.push('group_id', this.product.buy_group);
          api.query();
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.item {
  transition: background .2s ease;

  .card {
    min-height: 184px;
    padding: 18px;
    border-bottom: 1px solid var(--border-soft, #E8E4DE);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 28px;

    .info {
      display: flex;
      flex-direction: row;
      align-items: center;
      min-width: 0;
      flex: 1;

      .img {
        width: 146px;
        height: 146px;
        flex-shrink: 0;
        box-shadow: 0 8px 18px rgba(26, 29, 36, 0.08);
        margin: 0 20px 0 0;
        border-radius: 4px;
        overflow: hidden;
        background: var(--bg-tag, #F0EDE8);

        /deep/ img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .text {
        width: 100%;
        min-width: 0;
        max-width: 430px;

        .time {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          line-height: 20px;
          padding: 0 0 10px;
          border-bottom: 1px solid var(--border-soft, #E8E4DE);
        }

        .name {
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 500;
          color: var(--text-main, #111827);
          line-height: 24px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          word-break: break-all;
          margin: 12px 0 8px;

          span {
            display: inline-block;
            font-size: 14px;
            line-height: 20px;
            color: var(--primary, #FF5A1F);
            text-align: CENTER;
            padding: 1px 8px;
            border: 1px solid rgba(255, 90, 31, .38);
            border-radius: 4px;
            margin: 0 8px 0 0;
            background: var(--primary-soft, #FCEDE5);
          }
        }

        .sign {
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 24px;
          margin: 0 0 8px;

          img {
            height: 20px;
            margin: 0 8px 0 0;
          }
        }

        .other {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 24px;

          div {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            line-height: 20px;
          }

          .zone {
            max-width: 260px;
            word-break: break-all;
          }

          .hot {
            flex-shrink: 0;
            text-align: left;
          }
        }
      }
    }

    .price {
      width: 126px;
      flex-shrink: 0;
      margin: 0;
      font-size: 20px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 600;
      text-align: center;
      color: var(--primary, #FF5A1F);
      line-height: 28px;
    }

    .btnGroup {
      width: 128px;
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      gap: 8px;

      div, a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 128px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 500;
        text-align: CENTER;
        cursor: pointer;
        text-decoration: none;
        transition: opacity .2s ease, box-shadow .2s ease, color .2s ease, background .2s ease, border-color .2s ease;
      }

      .infoBtn {
        color: #FFFFFF;
        background: var(--bg-dark, #1A1D24);
        border: 1px solid transparent;
        box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
      }

      .infoBtn:hover {
        opacity: .94;
        box-shadow: 0 10px 22px rgba(26, 29, 36, 0.22);
      }

      .cusSerBtn {
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
        border: 1px solid rgba(26, 29, 36, .20);
      }

      .cusSerBtn:hover {
        border-color: rgba(26, 29, 36, .38);
        background: #FFFFFF;
      }

      .delBtn {
        background: var(--bg-tag, #F0EDE8);
        border: 1px solid var(--border-soft, #E8E4DE);
        color: var(--text-secondary, #5A5F6B);
      }

      .delBtn:hover {
        color: var(--hot, #FF2D55);
        background: var(--primary-soft, #FCEDE5);
        border-color: rgba(255, 45, 85, .24);
      }
    }
  }


}

.item:hover {
  background: var(--bg-tag, #F0EDE8);
}

</style>
